var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-option",on:{"click":_vm.select}},[_c('span',[_vm._t("default"),_c('svg',{staticClass:"list-option__remove",attrs:{"width":"9","height":"9"},on:{"click":function($event){$event.stopPropagation();return _vm.remove.apply(null, arguments)}}},[_c('use',{attrs:{"xlink:href":"#plus-white"}})])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }